import { render, staticRenderFns } from "./MaisAcessoAps.vue?vue&type=template&id=099e9a75"
import script from "./MaisAcessoAps.vue?vue&type=script&lang=js"
export * from "./MaisAcessoAps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports